var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "typeswitch", value: "doen" },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row row--fields" }, [
        _c("div", { staticClass: "column small-24 medium-14" }, [
          _c(
            "div",
            { staticClass: "formfield input input--zip" },
            [_c("LocationSearch", { attrs: { name: "plaats" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row row--fields" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "formfield" }, [
            _c("div", { staticClass: "customselect" }, [
              _c(
                "select",
                { attrs: { name: "activity[]" } },
                _vm._l(_vm.selectItems, function (item) {
                  return _c(
                    "option",
                    { attrs: { value: "1" }, domProps: { value: item.value } },
                    [_vm._v(_vm._s(item.key))]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(2),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row row--fields" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "headersearch__title h5" }, [
          _vm._v("Ik wil iets doen"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column small-24 medium-10" }, [
      _c("div", { staticClass: "formfield select" }, [
        _c("div", { staticClass: "customselect" }, [
          _c("select", { attrs: { name: "distance" } }, [
            _c("option", { attrs: { value: "1" } }, [_vm._v("+ 10 km")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "2" } }, [_vm._v("+ 20 km")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "3" } }, [_vm._v("+ 30 km")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "4" } }, [_vm._v("+ 40 km")]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "btn__headersearch" }, [
          _c("button", { staticClass: "btn" }, [
            _vm._v("Zoeken in aanbod "),
            _c("i", { staticClass: "icon-arrow-right" }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }